import { FC, useEffect, useMemo } from 'react';

import { useMatchXeroPopupQueryParams } from '../../../../hooks/useMatchXeroPopupQueryParams';
import { Content } from '../Content/Content';
import type { ContentProps } from '../Content/Content.types';

export const ReMatchContent: FC<ContentProps> = (props) => {
    const { isLoading, bankAccounts, xeroBankAccounts, form } = props;

    const { bankAccountId } = useMatchXeroPopupQueryParams();

    const xeroBankAccountId = useMemo(() => {
        const selectedBankAccount = bankAccounts.find((bankAccount) => bankAccount.id === bankAccountId);

        if (selectedBankAccount?.xeroBankAccount) {
            return selectedBankAccount.xeroBankAccount.id;
        }

        return null;
    }, [bankAccounts, bankAccountId]);

    const sortedXeroBankAccounts = useMemo(
        () =>
            // selected xero bank account shouldn't be disabled and must be placed on top
            xeroBankAccounts
                .sort((account) => {
                    if (xeroBankAccountId) {
                        if (account.id === xeroBankAccountId) {
                            return -1;
                        }
                    }

                    return 0;
                })
                .map((xeroBankAccount) => {
                    if (xeroBankAccount.id === xeroBankAccountId) {
                        return {
                            ...xeroBankAccount,
                            disabled: false,
                        };
                    }

                    return xeroBankAccount;
                }),
        [xeroBankAccounts, xeroBankAccountId]
    );

    useEffect(() => {
        if (!isLoading && bankAccountId) {
            form.setValue('bankAccountId', bankAccountId);
        }
    }, [form, isLoading, bankAccountId, xeroBankAccountId]);

    useEffect(() => {
        xeroBankAccountId && form.setValue('xeroBankAccountId', xeroBankAccountId);
    }, [form, xeroBankAccountId]);

    return <Content {...props} xeroBankAccounts={sortedXeroBankAccounts} />;
};

ReMatchContent.displayName = 'ReMatchContent';
